<template>
  <v-container fluid>
    <v-row dense>
      <v-col class="text-h3 gray--text text--lighten-1"> Atendimentos </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="4">
        <v-text-field
          label="Busca de paciente"
          prepend-inner-icon="eva-search-outline"
          v-model="search"
          dense
          outlined
          background-color="white"
          clearable
        />
      </v-col>

      <v-col cols="3">
        <v-combobox v-if="lodash.isEmpty(doctorUsers)"
          label="carregando Médicos..."
          loading
          disabled
          v-model="doctor"
          dense
          hide-details
          outlined
          background-color="white"
        />
        <div v-else>
          <authorizationTwo
            permissionKey="configuration_attendance_search_by_doctor"
            can="save"
            v-slot:default="{ authorization, canSave }" >
            <template>
              <v-col class="pt-1" v-if="authorization && canSave">
                <v-combobox label="Selecione o(a) Médico(a)"
                  v-model="doctor"
                  dense
                  hide-details
                  outlined
                  :items="doctorUsers"
                  item-text="employee.name"
                  background-color="white"
                  />
              </v-col>
              <v-col class="pt-1" v-else>
              <v-combobox 
                label="Selecione o(a) Médico(a)"
                v-model="doctor"
                dense
                hide-details
                outlined
                :items="userLogged"
                item-text="employee.name"
                background-color="white"
              />
              </v-col>
            </template>
         </authorizationTwo>
        </div>
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="dayOfAttendance"
          placeholder=" "
          label="Data"
          type="date"
          dense
          outlined
          hide-details
          clearable
          background-color="white"
        />
      </v-col>

      <v-col cols="4">
        <v-btn 
          color="theme--dark light-blue"
          disabled
           v-if="lodash.isEmpty(dayOfAttendance)"
          >
          Buscar
         </v-btn>
        <v-btn
          color="theme--dark light-blue"
          v-else
          @click="searchAttendancesByDate">
          Buscar
         </v-btn>
      </v-col>

      
      <!-- <v-col cols="2"> -->
      <!--   <v-checkbox -->
      <!--     v-model="released" -->
      <!--     label="Liberados" -->
      <!--     dense -->
      <!--     class="font-weight-bold" -->
      <!--   > -->
      <!--   </v-checkbox> -->
      <!-- </v-col> -->
    </v-row>

    <v-layout v-if="loading">
      <!--<v-row v-if="lodash.isEmpty(attendancesByDate)" justify="center">-->
      <v-row justify="center">
        <v-col cols="6">
          <v-alert color="blue" outlined text type="info">
            Buscando...
          </v-alert>
        </v-col>
      </v-row>
    </v-layout>


    <v-layout v-if="lodash.isEmpty(attendancesByDate) && !loading">
      <!--<v-row v-if="lodash.isEmpty(attendancesByDate)" justify="center">-->
      <v-row justify="center">
        <v-col cols="6">
          <v-alert color="orange" outlined text type="info">
            Nenhum atendimento para ser exibido
          </v-alert>
        </v-col>
      </v-row>
    </v-layout>

    <v-layout v-else>
      <v-container fluid>
        <v-row v-for="item in attendancesByDate" :key="item.id">
          <v-col cols="12">
            <AttendanceItem :attendance="item" :refreshQueue="refreshQueue">
              <template v-slot:details="{ attendance }">
                <slot
                  name="attendance"
                  :attendance="attendance"
                  :refreshQueue="refreshQueue"
                >
                </slot>
              </template>
            </AttendanceItem>
          </v-col>
        </v-row>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import ATTENDANCES_BY_DATE from "@/graphql/attendance/attendances_by_date";
import AttendanceItem from "@/components/queues/attendance.vue";

export default {
  name: "AttendancesList",
  components: {
    AttendanceItem,
  },
  data() {
    return {
      loading: false,
      search: "",
      dayOfAttendance: new Date().toISOString().slice(0, 10),
      doctor: "",
      userLogged: {},
      //released: false,
      attendancesByDate: [],
    };
  },
  mounted() {
    // this.refreshQueue();
  },
  apollo: {
    users: {
      query: require("@/graphql/users.gql"),
      result() {
        if (this.$store?.state?.authentication?.user?.id) {
          let userId = this.$store.state.authentication.user.id;

          this.userLogged = this.lodash.find(this.doctorUsers, {
            id: userId,
          });
      }
    }
    },


    /*attendancesByDate: {
      query: ATTENDANCES_BY_DATE,
      deep: true,
      variables() {
        return {
          dayOfAttendance: this.dayOfAttendance,
        };
      },
      //fetchPolicy: "cache-and-network",
      pollInterval: 60000,
      skip() {
        return !this.dayOfAttendance;
      },
    }, */
  },
  computed: {
    doctorUsers() {
      return this.lodash.orderBy(
        this.lodash.filter(this.users, {
          employee: { employeeType: "doctor" },
        }),
        [
          (e) =>
            e.employee.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, ""),
        ],
        ["asc"]
      );
    },
    dischargedPatientsFilter() {
        return this.attendancesByDate;
    },

    doctorFilter() {
      if (!this.doctor) {
        return this.dischargedPatientsFilter;
      }
      return this.lodash.filter(
        this.dischargedPatientsFilter,
        function(e) {
          return e.employee.id === this.doctor.employee.id;
        }.bind(this)
      );
    },
    /*attendancesFiltered() {
      if (!this.search) {
        return this.doctorFilter;
      }

      return this.lodash.filter(
        this.doctorFilter,
        function(e) {
          let search = String(this.search)
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          let name = String(e.patient.name)
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          let warelineId = String(e.patient.warelineId)
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          return name.includes(search) || warelineId.includes(search);
        }.bind(this)
      );
    }, */
  },
  methods: {
    refreshQueue() {
      console.log("refresh");
      //this.$apollo.queries.attendancesByDate.refetch();
    },
    async searchAttendancesByDate() {
      this.loading = true;
      try {
        await this.fetchAttendancesByDate();
      } catch (error) {
        this.loading = false;
        console.error("Erro ao buscar pacientes:", error);
      }
    },
    async fetchAttendancesByDate() {
      const response = await this.$apollo.query({
        query: ATTENDANCES_BY_DATE,
        variables: {
          dayOfAttendance: this.dayOfAttendance,
          employeeId: this.doctor?.employee?.id,
          patientName: this?.search,
        },
        fetchPolicy: "no-cache",
      });
      this.loading = false;
      const attendancesOrdered = this.lodash.orderBy(response.data.attendancesByDate, ["name", "asc"]);
      this.attendancesByDate = attendancesOrdered;
    },
  },
};
</script>

<style lang="scss" scoped>
.attendance-header {
  color: var(--v-secondary2-base);
}
</style>
